import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  FolderKanban,
  ListTodo,
  KanbanSquare,
  Clock,
  FileBarChart,
  Settings,
  Users
} from 'lucide-react';
import { cn } from '../../lib/utils';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/projects', icon: FolderKanban, label: 'Projets' },
  { to: '/work-items', icon: ListTodo, label: 'Tâches' },
  { to: '/sprint', icon: KanbanSquare, label: 'Sprint' },
  { to: '/time-entries', icon: Clock, label: 'Temps' },
  { to: '/reports', icon: FileBarChart, label: 'Rapports', adminOnly: true },
  { to: '/users', icon: Users, label: 'Utilisateurs', adminOnly: true },
  { to: '/settings', icon: Settings, label: 'Paramètres' },
];

export const Sidebar = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  return (
    <aside className={cn(
      "sidebar pt-20 pb-6",
      "hidden lg:block"
    )}>
        <nav className="flex flex-col gap-1 px-3">
          {navItems
            .filter((item) => !item.adminOnly || isAdmin)
            .map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => cn(
                "flex items-center gap-3 px-4 py-3 rounded-sm text-sm font-medium transition-colors",
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              )}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>
    </aside>
  );
};
